//comunicación entre componentesd
import { Component,  OnInit } from '@angular/core';
import { TraductorService } from './servicios/traductor.service'
import { BarraComponent } from './componentes/barra/barra.component';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [TraductorService]
})
export class AppComponent {
  title = 'D2Dv3';

  constructor( 
    private _traductorServices: TraductorService
  ) {
  }

  ngOnInit(): void {

    // this._traductorServices.getEvento().subscribe(
    //   result => {
    //     console.log(result)
    //   }
    // )
    
  }

  // initTranslate(IdNom){
  //   return console.log(this.idnom = IdNom) 
    
  // }  
}
